import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'bit-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonComponent implements OnInit {
  @Input() shape: 'circle' | 'rectangle' = 'rectangle';
  @Input() width!: number;
  @Input() height!: number;
  @Input() widthUnit: string = 'px';
  @Input() heightUnit: string = 'px';

  constructor() {
  }

  ngOnInit(): void {
  }

}
